// Carrier portali /portal, uz
export default {
  accessOnly: "Faqat carrier portali uchun kirish.",
  signOut: "Chiqish",
  logout: "Chiqish",
  title: "Carrier portali",
  nav: { candidates: "Nomzodlar", jobs: "Vakansiyalar", account: "Hisob" },
  poweredBy: "{{company}} tomonidan",
  searchPlaceholder: "Nomzodlarni qidirish",
  status: { new: "Yangi", in_review: "Ko'rib chiqilmoqda", accepted: "Qabul qilindi", rejected: "Rad etildi" },
  all: "Hammasi",
  exp: { none: "—", months: "{{n}} oy", years_one: "{{count}} yil", years_other: "{{count}} yil" },
  allStates: "48 shtat",
  candidates: {
    title: "Nomzodlar",
    subtitle: "{{company}} tomonidan {{carrier}} ga yuborilgan haydovchilar",
    loadFailed: "Nomzodlarni yuklab bo'lmadi.",
    emptyTitle: "Nomzodlar yo'q",
    emptySearch: "\"{{q}}\" bo'yicha hech narsa topilmadi.",
    emptyDesc: "Rekruteringiz yuborgan haydovchilar shu yerda ko'rinadi.",
    col: { driver: "Haydovchi", job: "Vakansiya", cdl: "CDL / tajriba", state: "Shtat", submitted: "Yuborilgan", status: "Holat" },
    count: "{{total}} nomzoddan {{shown}} tasi",
  },
  panel: {
    accepted: "{{name}} qabul qilindi",
    acceptedDesc: "Rekruterga xabar berildi. Haydovchi tekshiruv bosqichiga o'tadi.",
    rejected: "{{name}} rad etildi",
    rejectedDesc: "Rekruterga xabar berildi.",
    decisionFailed: "Qarorni saqlab bo'lmadi.",
    submitted: "Yuborilgan {{date}} · {{job}}",
    close: "Tafsilotlarni yopish",
    phone: "Telefon",
    hidden: "Rekruter yashirgan",
    state: "Shtat",
    cdl: "CDL",
    class: "{{cls}} toifa",
    cdlExpires: "CDL muddati",
    medical: "Tibbiy karta",
    validUntil: "{{date}} gacha amal qiladi",
    experience: "Tajriba",
    endorsements: "Ruxsatnomalar",
    equipment: "Texnika",
    note: "Rekruter izohi",
    yourReply: "Sizning javobingiz",
    rejectionReason: "Rad etish sababi",
    documents: "Hujjatlar",
    documentsDesc: "Hujjatlar (CDL nusxasi, tibbiy karta) keyingi bosqichda keladi.",
    notShared: "Carrier'larga ko'rsatilmaydi: SSN, tug'ilgan sana, ichki izohlar, boshqa carrier'lardagi natijalar.",
    accept: "Qabul qilish",
    reject: "Rad etish",
    acceptTitle: "{{name}} ni qabul qilish",
    acceptDesc: "Haydovchi tekshiruv bosqichiga o'tadi. Rekruterga bildirishnoma boradi.",
    comment: "Izoh",
    commentPlaceholder: "Rekruter uchun ixtiyoriy izoh",
    rejectTitle: "{{name}} ni rad etish",
    rejectDesc: "{{job}} · rekruter sababni ko'radi.",
    confirmReject: "Rad etishni tasdiqlash",
    rejectReason: "Rad etish sababi",
    chooseReason: "Sababni tanlang",
    reasons: { mvr: "MVR / haydovchilik tarixi", experience: "Tajriba", drug: "Narkotik testi", psp: "PSP / avariya tarixi", noshow: "Kelmadi", other: "Boshqa" },
  },
  jobs: {
    title: "Vakansiyalar",
    subtitle: "Ochiq o'rinlaringiz va har biri bo'yicha nomzodlar",
    loadFailed: "Vakansiyalarni yuklab bo'lmadi.",
    emptyTitle: "Hali vakansiya yo'q",
    emptyDesc: "Rekruteringiz o'rinlarni siz nomingizdan qo'shadi.",
    col: { job: "Vakansiya", status: "Holat", states: "Shtatlar", openings: "O'rinlar", pay: "Maosh", homeTime: "Uyda bo'lish", equipment: "Texnika", candidates: "Nomzodlar", inReview: "Ko'rilmoqda", hired: "Ishga olindi" },
    hiredOf: "{{openings}} dan {{hired}} ishga olindi",
  },
  account: {
    title: "Hisob",
    card: "Sizning hisobingiz",
    name: "Ism",
    username: "Login",
    carrier: "Carrier",
    mc: "MC #",
    contact: "Hisob ma'lumotlarini o'zgartirish uchun rekruteringizga murojaat qiling.",
  },
};
